import React from "react";
import { useFamilyData } from "../../hooks/useFamilyData";

export default function AnalyticsCard({ familyId, isPro }) {
  const { history = [] } = useFamilyData(familyId);

  if (!isPro) {
    return null;
  }

  const stats = history.reduce((acc, entry) => {
    const title = entry.title || "Untitled";
    if (!acc[title]) acc[title] = { approves: 0, fails: 0 };
    if (entry.type === "approve") acc[title].approves += 1;
    if (entry.type === "fail" || entry.type === "expired") acc[title].fails += 1;
    return acc;
  }, {});

  const attemptsByKid = history.reduce((acc, entry) => {
    if (entry.type !== "approve" && entry.type !== "fail" && entry.type !== "expired") return acc;
    const name = entry.kidName || "Unknown";
    if (!acc[name]) acc[name] = { approves: 0, fails: 0 };
    if (entry.type === "approve") acc[name].approves += 1;
    if (entry.type === "fail" || entry.type === "expired") acc[name].fails += 1;
    return acc;
  }, {});

  const attemptsByTask = history.reduce((acc, entry) => {
    if (entry.type !== "approve" && entry.type !== "fail" && entry.type !== "expired") return acc;
    const title = entry.title || "Untitled";
    if (!acc[title]) acc[title] = { approves: 0, fails: 0 };
    if (entry.type === "approve") acc[title].approves += 1;
    if (entry.type === "fail" || entry.type === "expired") acc[title].fails += 1;
    return acc;
  }, {});

  const sortedStats = Object.entries(stats)
    .map(([title, data]) => {
      const total = data.approves + data.fails;
      const percentage = total > 0 ? Math.round((data.fails / total) * 100) : 0;
      return { title, percentage, total };
    })
    .filter(item => item.total > 0 && item.percentage > 0)
    .sort((a, b) => b.percentage - a.percentage);

  const topKids = Object.entries(attemptsByKid)
    .map(([name, data]) => {
      const total = data.approves + data.fails;
      const percentage = total > 0 ? Math.round((data.approves / total) * 100) : 0;
      return [name, percentage, total];
    })
    .sort((a, b) => b[1] - a[1])
    .slice(0, 5);

  const topTasks = Object.entries(attemptsByTask)
    .map(([title, data]) => {
      const total = data.approves + data.fails;
      const percentage = total > 0 ? Math.round((data.approves / total) * 100) : 0;
      return [title, percentage, total];
    })
    .sort((a, b) => b[1] - a[1])
    .slice(0, 5);

  return (
    <div className="glass parent-card">
      <h2>Problem Tracker (%)</h2>
      <div className="card-body">
        {sortedStats.length === 0 ? (
          <p style={{ opacity: 0.5, textAlign: 'center' }}>No failure data recorded yet.</p>
        ) : (
          sortedStats.map(item => (
            <div key={item.title} className="parent-list-item" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <strong>{item.title}</strong>
                <span style={{ color: 'var(--danger)' }}>{item.percentage}% Fail Rate</span>
              </div>
              <small style={{ opacity: 0.6 }}>{item.total} attempts</small>
              <div className="progress-bg" style={{ height: '6px', width: '100%', marginTop: '8px', background: 'rgba(0,0,0,0.1)', borderRadius: '10px' }}>
                <div style={{ width: `${item.percentage}%`, background: 'var(--danger)', height: '100%', borderRadius: '10px' }} />
              </div>
            </div>
          ))
        )}

        <h3 style={{ marginTop: "15px" }}>Top Completions by Kid</h3>
        {topKids.length === 0 ? (
          <p style={{ opacity: 0.5, textAlign: "center" }}>No attempts yet.</p>
        ) : (
          topKids.map(([name, percentage, total]) => (
            <div key={name} className="parent-list-item">
              <span>{name}</span>
              <div style={{ textAlign: "right" }}>
                <strong>{percentage}%</strong>
                <div style={{ fontSize: "0.75rem", opacity: 0.6 }}>{total} attempts</div>
              </div>
            </div>
          ))
        )}

        <h3 style={{ marginTop: "15px" }}>Top Completed Tasks</h3>
        {topTasks.length === 0 ? (
          <p style={{ opacity: 0.5, textAlign: "center" }}>No attempts yet.</p>
        ) : (
          topTasks.map(([title, percentage, total]) => (
            <div key={title} className="parent-list-item">
              <span>{title}</span>
              <div style={{ textAlign: "right" }}>
                <strong>{percentage}%</strong>
                <div style={{ fontSize: "0.75rem", opacity: 0.6 }}>{total} attempts</div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
